export default __webpack_public_path__ + "static/media/clock_white.003b28e0.svg";